<template>
  <div id="app" :class="{'coze': iscoze}">
    <div class="bgs">

      <div class="appmains">
        <HeaderComponent></HeaderComponent>
        <el-container>
          <el-aside class="sidebar" v-if="iscoze"> 
          </el-aside>
          <el-main> 
            <router-view />
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
export default {
  name: "App",
  components: {
    HeaderComponent
  },
  data() {
    return {
      iscoze: false
    };
  },
  watch: {
    $route(to) {
      if (to.path == '/cozeIndex') {
        this.iscoze = false
      }
    }
  },
  mounted() {
    let path = this.$route.path
    if (path == '/cozeIndex') {
      this.iscoze = false
    }
  },


};
</script>

<style lang="scss">
*{
  box-sizing: border-box;
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  font-family: "SourceHanSansCN-Heavy";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: #111318; 
  color: #fff;
  // overflow: hidden;
  // overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  
  .bgs{
    background: #111318; 
  }
  .appmains{
    width: 100%;
    min-height: 100%;
    padding-top: 70px;
    box-sizing: border-box;
    background:url("http://cdn.gugusj.com/xdk/bg11.png") no-repeat;
    background-size: 1416px auto;
    background-position:  center 400px;
    .el-container {
      width: 100%;
      height: calc(100vh - 70px);
      overflow: hidden;
    }

    .el-main {
      padding: 0;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
.sidebar {
  width: 270px;
}  
}
.coze {
  background: url('http://cdn.gugusj.com/xdk/indexbg1.png') no-repeat top center !important;
  background-size: cover;
}

/* 非指定路由隐藏百度商桥在线咨询浮窗 */
body.hide-baidu-consult #newBridge,
body.hide-baidu-consult .newBridge-bar,
body.hide-baidu-consult #aff-im-root,
body.hide-baidu-consult #zc__sdk__container,
body.hide-baidu-consult [id*="bd-im"],
body.hide-baidu-consult [class*="newBridge"],
body.hide-baidu-consult iframe[src*="baidu.com"],
body.hide-baidu-consult iframe[src*="affim"] {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
  height: 0 !important;
  max-height: 0 !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}

html,
body {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue